import { typedGql } from '../../../__generated__/gql/zeus/typedDocumentNode.ts';

export const query = typedGql('query');
